import { useMutation } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import { useNavigate } from 'react-router-dom';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function UseSignUp(mail) {
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.REGISTER_SUPER_ADMIN,
        data
      );

      return response.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
        navigate(`/auth/verify/?email=${mail}`, { replace: true });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
